import React from 'react';
import SvgIcon from './SvgIcon';

const MassShooting = props => (
    <SvgIcon viewBox="0 0 26 24" {...props}>
        <path
            d="M25 12.5a.5.5 0 01-.5.5H23v-3h1.5a.5.5 0 01.5.5v2zM23 13H5M17 9h-5v2h5V9zM23 9V8M9 8.25A.25.25 0 008.75 8h-.5a.25.25 0 00-.25.25V9h1v-.75z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.714 9c-.454 0-.89.174-1.212.482A1.615 1.615 0 005 10.647v3.835a.4.4 0 00.07.226c.046.067.11.12.187.151a2.958 2.958 0 011.473 1.339c.314.596.404 1.279.253 1.932l-1.01 4.37a.396.396 0 00.084.346.427.427 0 00.334.154H11l1.714-7.412h9.857a.437.437 0 00.303-.12.404.404 0 00.126-.291V9H6.714z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16 16l-.384 1.632c-.094.399-.274.745-.514.991-.241.246-.53.377-.827.377H12M11 23h2M21 5.5a.5.5 0 01-.5.5H19V3h1.5a.5.5 0 01.5.5v2zM19 6H1M13 2H8v2h5V2zM19 2V1M5 1.25A.25.25 0 004.75 1h-.5a.25.25 0 00-.25.25V2h1v-.75z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.5 16H2.391a.444.444 0 01-.334-.154.406.406 0 01-.084-.347l1.01-4.37a2.785 2.785 0 00-.253-1.931 2.957 2.957 0 00-1.473-1.339.425.425 0 01-.187-.151.4.4 0 01-.07-.226V3.647c0-.437.18-.856.502-1.165A1.75 1.75 0 012.714 2H19v6.86"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

MassShooting.displayName = 'MassShootingIcon';

export default MassShooting;
